import { FC } from "react";

export type MessagePropTypes = {
  message: string;
  type: "success" | "error" | "validationError";
};

const getMessageInfo = (type: string) => {
  switch (type) {
    case "success":
      return {
        iconClassName: "bi bi-check-circle-fill me-1 text-success",
        style: { backgroundColor: "transparent" },
      };
    case "error":
      return {
        iconClassName: "bi bi-x-circle-fill me-1 text-danger",
        style: { backgroundColor: "transparent" },
      };
    case "validationError":
      return {
        iconClassName: "bi bi-exclamation-circle-fill me-1 text-danger",
        style: { backgroundColor: "#f0f0f0" },
      };
    default:
      return {
        iconClassName: "",
        style: {},
      };
  }
};
export const MessageComponent: FC<MessagePropTypes> = ({ message, type }) => {
  const messageInfo = getMessageInfo(type);

  return (
    <div>
      {message && (
        <div
          className={"mh-100 p-2 fw-light text-light text-center"}
          style={messageInfo.style}
        >
          {messageInfo.iconClassName && (
            <i className={messageInfo.iconClassName}></i>
          )}
          {message}
        </div>
      )}
    </div>
  );
};
